/**
 * An action run's outcome: status, exit code, output JSON and log tails.
 *
 * @module features/sandboxes/components/v2/detail/RunResultView
 */
import { Flex, Text } from '@chatsdet/ui';
import { formatDurationMs } from '../../../../../lib/formatDuration';
import type { SandboxV2Run } from '../../../hooks/useSandboxV2Detail';
import { RunStatusChip } from '../sandboxV2Display';

function Block({ label, text }: { label: string; text: string }) {
  return (
    <div>
      <Text size="xs" color="muted">
        {label}
      </Text>
      <pre className="mt-0.5 max-h-56 overflow-auto rounded-md bg-muted p-2 font-mono text-xs whitespace-pre-wrap break-all">
        {text}
      </pre>
    </div>
  );
}

export function RunResultView({ run }: { run: SandboxV2Run }) {
  return (
    <div className="flex flex-col gap-2">
      <Flex align="center" gap="sm" wrap="wrap">
        <RunStatusChip status={run.status} />
        {run.exitCode !== null && (
          <Text size="sm" color="muted">
            Exit code <span className="font-mono">{run.exitCode}</span>
          </Text>
        )}
        {run.durationMs !== null && (
          <Text size="sm" color="muted" className="tabular-nums">
            {formatDurationMs(run.durationMs)}
          </Text>
        )}
      </Flex>
      {run.error && <Block label="Error" text={run.error} />}
      {run.output && <Block label="Output" text={JSON.stringify(run.output, null, 2)} />}
      {run.stdoutTail && <Block label="stdout" text={run.stdoutTail} />}
      {run.stderrTail && <Block label="stderr" text={run.stderrTail} />}
    </div>
  );
}
